import * as Yup from "yup";

interface CreditorGroup extends Yup.MixedSchema {
  targetCreditorGroupId: string;
}

const CopyCGBMDSchema = Yup.object<CreditorGroup>().shape({
  targetCreditorGroupId: Yup.string().required("Add a value into the field."),
});

export default CopyCGBMDSchema;
